<template>
    <div class="group-rules">
        <label for="">Voeg regels aan jouw groep toe. Vul in en druk op het plusje om meerdere toe te voegen.</label>
        <div class="row">
      
            <div class="col-xs-12">
                <template v-if="rules.length > 0">
                    <div class="form-group" v-for="(rule,index) in rules">
                        <label class="col-md-2 control-label text-left">Regel #{{index+1}} </label> 
                        <div class="col-md-9">
                            <input placeholder="voeg een regel toe..." type="text" v-model="rule.name" class="form-control" @blur="saveRule(rule)" />
                        </div>
                        <div class="col-md-1 text-right">
                            <button class="btn btn-default" type="button" @click="removeRule(rule)"><i class="fa fa-times"></i></button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p>Deze groep heeft geen huisregels. Voeg er een toe door op het plus icoon te klikken.</p>
                </template>
            </div>
            <div>
                <label class="col-md-2 control-label text-left"></label> 
                <div class="col-md-9">
                    <button class="btn default m-b clearfix btn-xs" type="button" @click="addRule"><i class="fa fa-plus-circle"></i> een regel toevoegen</button>
                </div>
            </div>
            <div class="col-xs-12">
                <hr>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'group' ],
    data() {
        return {
            newRule: '',
            rules: [],
            groupInfo: {
                rules: []
            }
        }
    },
    mounted() {
        this.groupInfo = JSON.parse(this.group);
        this.rules = this.groupInfo.rules;
    },
    methods: {
        addRule() {
            let that = this;
            axios.post('/api/v3/rules', {'name': '', 'group_id': this.groupInfo.id}).then(function(response){
                that.rules.push(response.data.data);
            });
        },
        removeRule(rule) {
            let that = this;
            axios.delete(`/api/v3/rules/${rule.id}`).then(function(){
                that.rules.splice(that.rules.indexOf(rule), 1);
            });
        },
        saveRule(rule) {
            axios.put(`/api/v3/rules/${rule.id}`, rule);
        },
    },

}
</script>